// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';

import '@/styles/index.scss' // global css
import '@/assets/css/style.css' // global css
import server from '@/utils/request'
import api from '@/api'
import validate from '@/utils/validate'
import '@/utils/directives.js'
import CustomComponents from '@/components/index.js'

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/icons/svg/iconfont.js'
import '@/permission'

import * as timeFilter from '@/utils/filters'

Vue.use(ElementUI, { locale })
Object.keys(CustomComponents).forEach(key => Vue.use(CustomComponents[key]))

Vue.prototype.$ajax = server
Vue.prototype.$url = api
Vue.prototype.viewer = Viewer
Vue.prototype.$validate = validate

Object.keys(timeFilter).forEach(key => {
  Vue.filter(key, timeFilter[key])
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js